// extracted by mini-css-extract-plugin
export default {"root":"rKM4Xx","label":"GKTkQ_","icon":"kuys_N","first":"DUqfEM","previous":"_ra5Sa","last":"inFVHY","next":"ni9YRk"};